import { DEFAULT_TOAST_LIFE } from "../../../common/EzToast";
import {
  FETCH_CUSTOMERS,
  GENERATE_REPORT,
  TOAST,
} from "../../../constants/action-types/reporting";
import { reportingService, reportService } from "../../../Services";

export const generateReportStart = () => ({
  type: GENERATE_REPORT.START,
});

export const generateReportSuccess = (payload) => ({
  type: GENERATE_REPORT.SUCCESS,
  payload,
});

export const generateReportError = (payload) => ({
  type: GENERATE_REPORT.ERROR,
  payload,
});

export const resetToast = () => ({
  type: TOAST.RESET,
});

export const generateReport = (payload) => {
  return (dispatch) => {
    dispatch(generateReportStart());

    reportingService.generateReport(payload).then((response) => {
      if (!response.isError) {
        dispatch(generateReportSuccess(response));
      } else {
        dispatch(generateReportError(response));
      }

      setTimeout(() => {
        dispatch(resetToast());
      }, DEFAULT_TOAST_LIFE + 1000);
    });
  };
};

export const fetchCustomersStart = () => ({
  type: FETCH_CUSTOMERS.START,
});

export const fetchCustomersSuccess = (payload) => ({
  type: FETCH_CUSTOMERS.SUCCESS,
  payload,
});

export const fetchCustomersError = (payload) => ({
  type: FETCH_CUSTOMERS.ERROR,
  payload,
});

export const fetchFuelCustomers = (payload) => {
  return (dispatch) => {
    dispatch(fetchCustomersStart());

    reportingService.getCustomers(payload).then((response) => {
      if (!response.isError) {
        dispatch(fetchCustomersSuccess(response));
      } else {
        dispatch(fetchCustomersError(response));
      }
    });
  };
};
